import BaseAPI from '@/services/api/internal/tools/baseAPI';
import { errorHandler } from '@/business/apiTreatment/response/baseAPITreatment';
import Client from '@/services/api/internal/tools/client.js';

const URL = `${process.env.P2C_BASE_URI}/dashboard/dispatcher`;

const dashboardDispatcherAPI = new BaseAPI({ url: URL });

export function getGraphsDispatcherAPI(body) {
  return Client.post(`${URL}/graphs`, body).catch(errorHandler);
}

export default dashboardDispatcherAPI;
